import { render, staticRenderFns } from "./SliderV5.vue?vue&type=template&id=416ddeca&"
import script from "./SliderV5.vue?vue&type=script&lang=js&"
export * from "./SliderV5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports